import { useEffect } from 'react'

import { Drawer, useDrawerStackContext } from '@mantine/core'

const DnDrawer = ({ children, stackId, ...props }) => {
  const stackCtx = useDrawerStackContext()

  // Mantine gap: Drawer's stack-register useEffect has no cleanup, so
  // unmounting while opened leaks the stackId in Drawer.Stack (ENG-3772).
  useEffect(() => {
    return () => {
      if (stackCtx && stackId) {
        stackCtx.removeModal(stackId)
      }
    }
  }, [])

  return (
    <Drawer
      opened={props.opened}
      onClose={props.onClose}
      position="right"
      withCloseButton={false}
      size={'30%'}
      offset={6}
      radius="md"
      overlayProps={{ backgroundOpacity: 0.2 }}
      classNames={{
        content: 'h-screen overflow-hidden',
      }}
      stackId={stackId}
      {...props}
    >
      {children}
    </Drawer>
  )
}

export default DnDrawer
